export const USER_VIEW_TAB_VISIBILITY = {
  giftCodesRedeemed: false,
  reclaimPoints: false,
};
